import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { merge, Observable } from 'rxjs';
import {
  getAccessToken,
  getAccountId,
  getAuthenticated,
  getAuthenticatedThroughBilling,
  getMfaExchangeToken,
  getRedirectPath,
  getRefreshToken,
  getTokensLoaded,
  getUserId,
  initialState,
} from './auth-data.reducer';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class AuthDataStore {
  appAuthenticated$: Observable<boolean> = this._store
    .select(getAuthenticated)
    .pipe(
      filter((authenticated) => authenticated !== initialState.authenticated)
    );
  authenticated$: Observable<boolean> = merge(
    this.appAuthenticated$,
    this._store
      .select(getAuthenticatedThroughBilling)
      .pipe(
        filter(
          (authenticatedThroughBilling) =>
            authenticatedThroughBilling !==
            initialState.authenticatedThroughBilling
        )
      )
  );

  accountId$: Observable<string> = this._store
    .select(getAccountId)
    .pipe(filter((accountId: string) => accountId !== initialState.accountId));
  userId$: Observable<string> = this._store
    .select(getUserId)
    .pipe(filter((userId: string) => userId !== initialState.userId));
  redirectPath$: Observable<string> = this._store.select(getRedirectPath);
  accessToken$: Observable<string> = this._store
    .select(getAccessToken)
    .pipe(
      filter((accessToken: string) => accessToken !== initialState.accessToken)
    );
  mfaExchangeToken$: Observable<string> = this._store
    .select(getMfaExchangeToken)
    .pipe(
      filter(
        (mfaExchangeToken: string) =>
          mfaExchangeToken !== initialState.mfaExchangeToken
      )
    );
  refreshToken$: Observable<string> = this._store
    .select(getRefreshToken)
    .pipe(
      filter(
        (refreshToken: string) => refreshToken !== initialState.refreshToken
      )
    );

  constructor(private _store: Store<any>) {}

  isAuthenticated(includeBilling?: boolean): Observable<boolean> {
    return (includeBilling ? this.authenticated$ : this.appAuthenticated$).pipe(
      take(1)
    );
  }

  getRedirectPath(): Observable<string> {
    return this.redirectPath$.pipe(take(1));
  }

  getAccountId(): Observable<string> {
    return this.accountId$.pipe(take(1));
  }

  getUserId(): Observable<string> {
    return this.userId$.pipe(take(1));
  }

  getAccessToken(): Observable<string> {
    return this.accessToken$.pipe(take(1));
  }

  getRefreshToken(): Observable<string> {
    return this.refreshToken$.pipe(take(1));
  }

  getMfaExchangeToken$(): Observable<string> {
    return this.mfaExchangeToken$.pipe(take(1));
  }

  getTokensLoaded(): Observable<boolean> {
    return this._store.select(getTokensLoaded).pipe(
      filter(
        (tokensLoaded: boolean) => tokensLoaded !== initialState.tokensLoaded
      ),
      take(1)
    );
  }
}
